export enum MapTypeEnum {
  ROADMAP = 'roadmap',
  SATELLITE = 'satellite',
  HYBRID = 'hybrid',
  TYPE_DEFAULT = 'hybrid',
}
